<template>
    <zone
        auto-height
        contrast="light"
        :align="alignment"
        :background-image="images.background"
        :class="classes"
        :data-label="dico.dataLabel"
        :id="dico.id"
        v-if="isDisplayed"
    >
        <heading :level="2" v-html="dico.title" />
        <paragraph :size="sizes.text" :content="dico.text" />
        <cta
            is-btn
            class="g_btnGold"
            type="text"
            :content="dico.cta.content"
            :link="dico.cta.link"
            v-if="dico.cta"
            @click="trackAction(dico.cta.content)"
        />
    </zone>
</template>

<script>
import Cta from 'gvue/src/core/Cta'
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Zone from 'gvue/src/core/Zone'
import Tracking from 'nespresso-library/src/core/tracking'

import { getBackground } from '@/helpers/visual'

export default {
    name: 'SectionBanner',
    components: {
        Cta,
        Heading,
        Paragraph,
        Zone
    },
    props: {
        dicoKey: {
            type: String,
            required: true
        }
    },
    computed: {
        dico () {
            return this.$json[this.dicoKey]
        },
        alignment () {
            return this.$breakpoint.isS ? 'center' : this.dico.align
        },
        classes () {
            return { reverse: this.dico.align === 'left' }
        },
        images () {
            return { background: getBackground(this.dico.background) }
        },
        sizes () {
            return { text: this.$breakpoint.isS ? 'M' : 'XL' }
        },
        isDisplayed () {
            return this.dico.display
        }
    },
    methods: {
        trackAction (text) {
            Tracking.customEvent({
                category: 'User Engagement',
                action: 'Click',
                label: `${this.$landing.trackingLabelPrefix} - ${text}`,
                interaction: 0
            })
            debugger
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.g
    .g_text
        > .g_btn
            margin-top: ($gap * 4)
+mobile
    .g_section
        display: flex
        flex-direction: column

        &.reverse
            flex-direction: column-reverse

    .g
        .g_text
            > .g_btn
                width: 100%

    /deep/
        .g_bg
            padding-top: 116%
            position: static

@media screen and (min-width: 768px)
    /deep/
        .g_bg
            background-size: auto 100%

    .g_left /deep/ .g_bg
        background-position: 50vw center

    .g_right /deep/ .g_bg
        background-position: calc(100% - 50vw) center

@media screen and (min-width: 1200px)
    .g_right /deep/ .g_bg
        background-position: calc(50% - 33.125em) center

@media screen and (min-width: 1920px)
    /deep/
        .g_bg
            background-size: auto 100%
</style>
